import type { ComponentStyleConfig } from "@chakra-ui/theme";

export const commonSliderStyle = {
	position: "relative",

	"& .swiper-slide": {
		height: "auto",

		"> div": {
			height: "full",

			"> div:first-of-type": {
				marginTop: { base: "auto", lg: "unset" },
			},
		},
	},
};

const HeroSlider: ComponentStyleConfig = {
	baseStyle: () => ({
		wrapper: {
			...commonSliderStyle,
		},
	}),
};

export default HeroSlider;
